import { render } from "./NewsletterFour.vue?vue&type=template&id=a8c1d050"
import script from "./NewsletterFour.vue?vue&type=script&lang=js"
export * from "./NewsletterFour.vue?vue&type=script&lang=js"

import exportComponent from "/Users/larijuva/suha-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__